import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

//const baseURL = "http://localhost:3001";
const baseURL = "https://atci.lkm.eitacademy.accenture.com/ips-apis";

export const UsersSlice = createSlice({
  name: "UserList",
  initialState: {
    usersData: [],
    newUser: "",
    updateStatus: null,
  },
  reducers: {
    setError: (state) => {
      state.error = true;
      state.updateStatus = "error";
    },
    setUpdateStatus: (state, { payload }) => {
      state.updateStatus = payload; // can be "success" or "error"
    },
    resetUpdateStatus: (state) => {
      state.updateStatus = null; // reset the status to close the modal
    },
    setUsersData: (state, { payload }) => {
      state.error = false;
      state.usersData = payload;
    },
    setNewUser: (state, { payload }) => {
      state.error = false;
      state.newUser = payload;
    },
  },
});

export const {
  setError,
  setUsersData,
  setNewUser,
  setUpdateStatus,
  resetUpdateStatus,
} = UsersSlice.actions;
export default UsersSlice.reducer;

export function getUsers() {
  return (dispatch) => {
    axios
      .get(`${baseURL}/getUsers?date=${new Date().getTime()}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        dispatch(setUsersData(res.data.results));
        console.log("GET USERS *****");
      })
      .catch((err) => {
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}

export function addUser(username) {
  return (dispatch, getState) => {
    const { usersData } = getState().users;
    console.log(usersData, "userdata");
    const isDuplicate = Array.isArray(usersData)
      ? usersData.some(
          (user) => user.Enterprise_ID?.toLowerCase() === username.toLowerCase()
        )
      : [];
    if (isDuplicate) {
      dispatch(setUpdateStatus("duplicate"));
      return;
    }
    axios
      .post(
        `${baseURL}/adduser`,
        { username },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        dispatch(setUpdateStatus("success"));
        dispatch(setNewUser(username));
        dispatch(getUsers());
        console.log("res from post api", res.data);
      })
      .catch((err) => {
        dispatch(setUpdateStatus("error"));
        dispatch(setError(err));
        console.error("error is", err);
      });
  };
}
